import { ADDONS_SELECT_TYPE, CLOSE, OPEN } from '../../utils/constants';
import { appointmentChannelId, form, isClickCheckBox, procedures } from '../../utils/variables';
import {
    addAddons,
    applyAddon,
    applyAddons,
    isCheckedAddons,
    removeAddons,
    removeAllAddons,
    toggleAddonDescription,
    toggleAddonsPopup,
} from '../actions/addonActions';
import { addProcedure } from '../actions/procedureActions';

export function addonListeners() {
    /* on click outside to close pop up */
    clickOutsideToClosePopup();

    /* on click "No Add-Ons" */
    clickNoAddons();

    /* on select addon */
    onSelectAddons();

    /* On click Add Add-Ons button */
    clickAddAddons();

    /* On show addon description popup */
    openAddonDescription();

    /* On click Close description addon */
    closeAddonDescription();

    /* On click outside to close description addon */
    clickOutsideToCloseDescription();

    /* On click Apply btn */
    clickApplyButton();
}

function clickOutsideToClosePopup() {
    const bg = document.querySelectorAll(`.popup__background.addons`);
    bg.forEach((i) => {
        const procedureList = (appointmentChannelId && form?.appointment_channel?.procedures?.length >= 1) ? form?.appointment_channel?.procedures : procedures;
        const { id } = procedureList.find(
            (p) => p.id === parseInt(i.getAttribute('data-procedure-id'))
        );
        const category = i.getAttribute('data-category');

        i.onclick = () => {
            if (isClickCheckBox) {
                toggleAddonsPopup(id, category, CLOSE);
                addProcedure(id);
            } else {
                toggleAddonsPopup(id, category, CLOSE);
                removeAllAddons(id);
            }
        };
    });
}

function clickNoAddons() {
    const btn = document.querySelectorAll('.addons__closeBtn');
    btn.forEach((i) => {
        const id = parseInt(i.getAttribute('data-procedure-id'));
        const category = i.getAttribute('data-category');

        i.onclick = () => {
            toggleAddonsPopup(id, category, CLOSE);
            removeAllAddons(id);
            addProcedure(id);
        };
    });
}

function onSelectAddons() {
    const checkBox = document.querySelectorAll('.line__wrapper.addon');
    const procedureList = (appointmentChannelId && form?.appointment_channel?.procedures?.length >= 1) ? form?.appointment_channel?.procedures : procedures;
    checkBox.forEach((i) => {
        const procedureId = i.getAttribute('data-procedure-id');
        const addonId = i.getAttribute('data-addon-id');
        const selectType = procedureList.find(
            (p) => p.id === parseInt(procedureId)
        ).addons_select_type;

        i.onclick = () => {
            if (selectType === ADDONS_SELECT_TYPE.MULTI_SELECT) {
                if (isCheckedAddons(procedureId, addonId)) {
                    removeAddons(procedureId, addonId);
                } else {
                    addAddons(procedureId, addonId);
                }
            } else if (selectType === ADDONS_SELECT_TYPE.SINGLE_SELECT) {
                removeAllAddons(procedureId);
                addAddons(procedureId, addonId);
            }
        };
    });
}

function clickAddAddons() {
    const addBtn = document.querySelectorAll('.addons__applyAddonBtn');

    addBtn.forEach((i) => {
        const procedureId = parseInt(i.getAttribute('data-procedure-id'));
        const category = i.getAttribute('data-category');

        i.onclick = () => {
            applyAddons(procedureId);
            toggleAddonsPopup(procedureId, category, CLOSE);
        };
    });
}

function openAddonDescription() {
    const infoBtn = document.querySelectorAll('.procedure__information.addon');
    infoBtn.forEach((i) => {
        i.onclick = (e) => {
            e.stopPropagation();
            toggleAddonDescription(
                i.getAttribute('data-procedure-id'),
                i.getAttribute('data-addon-id'),
                i.getAttribute('data-category'),
                OPEN
            );
        };
    });
}

function closeAddonDescription() {
    const closeInfoBtn = document.querySelectorAll('.addon-body__close-btn');
    closeInfoBtn.forEach((i) => {
        i.onclick = () => {
            toggleAddonDescription(
                i.getAttribute('data-procedure-id'),
                i.getAttribute('data-addon-id'),
                i.getAttribute('data-category'),
                CLOSE
            );
        };
    });
}

function clickOutsideToCloseDescription() {
    const bgDescription = document.querySelectorAll(
        '.popup__background.addon__information'
    );
    bgDescription.forEach((i) => {
        i.onclick = () => {
            toggleAddonDescription(
                i.getAttribute('data-procedure-id'),
                i.getAttribute('data-addon-id'),
                i.getAttribute('data-category'),
                CLOSE
            );
        };
    });
}

function clickApplyButton() {
    const applyBtn = document.querySelectorAll('.addonBody__applyBtn');
    applyBtn.forEach((i) => {
        i.onclick = () => {
            applyAddon(
                i.getAttribute('data-procedure-id'),
                i.getAttribute('data-addon-id'),
                i.getAttribute('data-category')
            );
        };
    });
}
